'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _extends =
  Object.assign ||
  function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i]
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key]
        }
      }
    }
    return target
  }

var _templateObject = _taggedTemplateLiteral(
  ['\n  flex: none;\n  ', ' ', ';\n'],
  ['\n  flex: none;\n  ', ' ', ';\n']
)

var _react = require('react')

var _react2 = _interopRequireDefault(_react)

var _styledComponents = require('styled-components')

var _styledComponents2 = _interopRequireDefault(_styledComponents)

var _styledSystem = require('styled-system')

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _icons = require('../icons.js')

var _icons2 = _interopRequireDefault(_icons)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

function _objectWithoutProperties(obj, keys) {
  var target = {}
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue
    target[i] = obj[i]
  }
  return target
}

var Base = function Base(_ref) {
  var name = _ref.name,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, ['name', 'size'])

  var path = _icons2.default[name]
  if (!path) return false

  return _react2.default.createElement(
    'svg',
    _extends({}, props, {
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      fill: 'currentcolor'
    }),
    _react2.default.createElement('path', { d: path })
  )
}

var Icon = (0, _styledComponents2.default)(Base)(
  _templateObject,
  _styledSystem.space,
  _styledSystem.color
)

Icon.displayName = 'Icon'

Icon.defaultProps = {
  name: 'flag',
  size: 24
}

Icon.propTypes = {
  name: _propTypes2.default.oneOf(Object.keys(_icons2.default)).isRequired,
  size: _propTypes2.default.oneOfType([
    _propTypes2.default.string,
    _propTypes2.default.number
  ])
}

exports.default = Icon



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/MDIcon.js
// module id = 356
// module chunks = 168707334958949